import { TextField, MenuItem } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

export const HistoricDispositionCapture = ({
  dispositions,
  setHistoricDisposition,
}: any) => {
  return (
    // <TextField
    //   id="historicDisposition"
    //   type="text"
    //   data-testid="historicDisposition"
    //   name="historicDisposition"
    //   select={true}
    //   label="Pick a disposition"
    //   fullWidth
    // >
    //   {dispositions?.map((disposition: any) => (
    //     <MenuItem
    //       key={disposition.id}
    //       value={disposition.url}
    //       onClick={() => setHistoricDisposition(disposition)}
    //     >
    //       {disposition.name}
    //     </MenuItem>
    //   ))}
    // </TextField>
    <Autocomplete
      id="historicDisposition"
      options={dispositions || []}
      getOptionLabel={(option: any) => option?.name || ""}
      onChange={(_event, value) => setHistoricDisposition(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Pick a disposition"
          name="historicDisposition"
          fullWidth
          data-testid="historicDisposition"
          variant="standard"
        />
      )}
    />
  );
};
